<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- <el-menu :default-active="activeName" class="el-menu-demo" @select="handleSelect" mode="horizontal" style="width: 100%;"
		background-color="#fff">
			<el-menu-item index="1">商品套餐</el-menu-item>
			<el-menu-item index="2">疫苗套餐</el-menu-item>
			<el-menu-item index="3">驱虫套餐</el-menu-item>
			<el-menu-item index="4">服务套餐</el-menu-item>
		</el-menu> -->
		<div class="tabLine">
			<div class="tabItem" :class="[activeName=='1'?'active':'']" @click="handleSelect('1')">商品套餐</div>
			<div class="tabItem" :class="[activeName=='2'?'active':'']" @click="handleSelect('2')">疫苗套餐</div>
			<div class="tabItem" :class="[activeName=='3'?'active':'']" @click="handleSelect('3')">驱虫套餐</div>
			<div class="tabItem" :class="[activeName=='4'?'active':'']" @click="handleSelect('4')">服务套餐</div>
		</div>
		
		<div class="searchbox">
			<div style="margin-left: 10px;">
				<el-input style="width:160px;margin-right: 10px;" placeholder="请输入名称" v-model="params.keyword" @keyup.enter.native="clickSearch"
				clearable size="small"></el-input>
				<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
			</div>
			<div style="margin-left: 10px;">
				<el-select v-model="params.shopId" placeholder="请选择" clearable @change="clickSearch" size="small" style="width: 120px;">
					<el-option v-for="item in this.$store.state.userInfo.shops" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
					</el-option>
				</el-select>
			</div>
			<div style="margin-left: 10px;">
				<el-select v-model="params.applytype" placeholder="请选择种类" clearable @change="clickSearch" size="small" style="width: 120px;">
					<el-option label="通用" value="0"></el-option>
					<el-option label="犬用" value="2"></el-option>
					<el-option label="猫用" value="1"></el-option>
				</el-select>
			</div>
			<div style="flex: 1;text-align: right;">
				<el-button v-if="$buttonAuthority('chanpin-group-add')" icon="el-icon-plus" type="warning" @click='addGoods()' size="small">
				新建<span v-if="activeName=='1'">商品</span>
				<span v-if="activeName=='2'">疫苗</span>
				<span v-if="activeName=='3'">驱虫</span>
				<span v-if="activeName=='4'">服务</span>套餐
				</el-button>
			</div>
		</div>
		<div class="con">
			<div class="left">
				<el-button style="margin-left: 20px;" size="mini" @click="addProductType('')">添加</el-button>
				<el-button size="mini" type="warning" @click="resetProductType">重置</el-button>
				<el-tree class="elTree" style="margin-top: 10px;" v-if="categoryData[0]" :data="categoryData[0].children" :highlight-current='isHighlight'
				node-key="id" default-expand-all :expand-on-click-node="false" :render-content="renderContent" @node-click='handleNodeClick'>
				</el-tree>
			</div>
			<div style="flex: 1;background: #fff;">
				<div class="table" v-if="activeName=='1'">
					<el-table :data="goodsGroupData" size="small">
						<el-table-column prop="title" label="名称">
							<template slot-scope="scope">
								{{scope.row.title}} {{scope.row.buy_back == 0?'不复购':'复购'}}
							</template>
						</el-table-column>
						<el-table-column prop="name" label="适用宠物">
							<template slot-scope="scope">
								<span>{{scope.row.apply_type.title}}</span>
							</template>
						</el-table-column>
						
						<el-table-column label="分类">
							<template slot-scope="scope">
								<span>{{scope.row.category_info.name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="套餐售价" >
							<template slot-scope="scope">
								<span>{{scope.row.total_money}}</span>
							</template>
						</el-table-column>
						<el-table-column label="是否参与提成" >
							<template slot-scope="scope">
								<span v-if="scope.row.join_commission==0">否</span>
								<span v-else>是</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">
							<template slot-scope="scope">
								<el-button v-if="$buttonAuthority('chanpin-group-edit')" type="text" icon='el-icon-edit' size="small" @click='edit(scope.row.groupId,1)'>编辑</el-button>
								
								<!-- <el-button type="text" icon='el-icon-view' size="small" @click='lookdetail(scope.row._id)'>查看</el-button> -->
								<el-button v-if="$buttonAuthority('chanpin-group-del')" type="text" icon='el-icon-delete' size="small" @click='deleted(scope.row.groupId,1)'>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="table" v-if="activeName=='2'">
					<el-table :data="yimiaoGroupData" style="width: 100%" size="small">
						<el-table-column prop="title" label="名称">
						</el-table-column>
						<el-table-column prop="name" label="适用宠物">
							<template slot-scope="scope">
								<span>{{scope.row.apply_type.title}}</span>
							</template>
						</el-table-column>
						<el-table-column label="项目类型">
							<template slot-scope="scope">
								<span>{{scope.row.buy_way.title}}</span>
							</template>
						</el-table-column>
						<el-table-column label="分类">
							<template slot-scope="scope">
								<span>{{scope.row.category_info.name}}</span>
							</template>
						</el-table-column>
						
						<el-table-column label="操作" width="180px">
							<template slot-scope="scope">
								<el-button v-if="$buttonAuthority('chanpin-group-edit')" type="text" icon='el-icon-edit' size="small" @click='edit(scope.row.groupId,2)'>编辑</el-button>
								<el-button type="text"  size="small" @click='relationconsum(scope.row,3)'>关联耗材</el-button>
								<!-- <el-button type="text" icon='el-icon-view' size="small" @click='lookdetail(scope.row._id)'>查看</el-button> -->
								<el-button v-if="$buttonAuthority('chanpin-group-del')" type="text" icon='el-icon-delete' size="small" @click='deleted(scope.row.groupId,2)'>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="table" v-if="activeName=='3'">
					<el-table :data="quchongGroupData" style="width: 100%" size="small">
						<el-table-column prop="title" label="名称">
						</el-table-column>
						<el-table-column prop="name" label="适用宠物">
							<template slot-scope="scope">
								<span>{{scope.row.apply_type.title}}</span>
							</template>
						</el-table-column>
						<el-table-column label="项目类型">
							<template slot-scope="scope">
								<span>{{scope.row.buy_way.title}}</span>
							</template>
						</el-table-column>
						<el-table-column label="分类">
							<template slot-scope="scope">
								<span>{{scope.row.category_info.name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">
							<template slot-scope="scope">
								<el-button v-if="$buttonAuthority('chanpin-group-edit')" type="text" icon='el-icon-edit' size="small" @click='edit(scope.row.groupId,3)'>编辑</el-button>
								<el-button type="text"  size="small" @click='relationconsum(scope.row,4)'>关联耗材</el-button>
								<!-- <el-button type="text" icon='el-icon-view' size="small" @click='lookdetail(scope.row._id)'>查看</el-button> -->
								<el-button v-if="$buttonAuthority('chanpin-group-del')" type="text" icon='el-icon-delete' size="small" @click='deleted(scope.row.groupId,3)'>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="table" v-if="activeName=='4'">
					<el-table :data="serviceGroupData" style="width: 100%" size="small">
						<el-table-column prop="title" label="名称">
						</el-table-column>
						<el-table-column prop="name" label="适用宠物">
							<template slot-scope="scope">
								<span>{{scope.row.apply_type.title}}</span>
							</template>
						</el-table-column>
						
						<el-table-column label="分类">
							<template slot-scope="scope">
								<span>{{scope.row.category_info.name}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="total_money" label="总价">
						</el-table-column>
						<el-table-column label="操作" width="120">
							<template slot-scope="scope">
								<el-button v-if="$buttonAuthority('chanpin-group-edit')" type="text" icon='el-icon-edit' size="small" @click='edit(scope.row.groupId,4)'>编辑</el-button>
								
								<!-- <el-button type="text" icon='el-icon-view' size="small" @click='lookdetail(scope.row._id)'>查看</el-button> -->
								<el-button v-if="$buttonAuthority('chanpin-group-del')" type="text" icon='el-icon-delete' size="small" @click='deleted(scope.row.groupId,4)'>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<page :total="total" :page="params.pageIndex" @change="changePage" style="padding: 10px 0;"></page>
			</div>

		</div>
		
		<el-dialog title="套餐类型设置" :visible.sync="dialogProductType" width="30%" :close-on-click-modal='false'>
			<el-form ref="editProductParams" label-width="80px">
				<el-form-item label="类型名称">
					<el-input v-model="editProductParams.typeName" size='mini' style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="onSubmitProductType">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import {
		getGoodsGroupList,
		getVaccineGroupList,
		getDewormingGroupList,
		getServiceGroupList,
		
		deleteGoodsGroup,
		deleteVaccineGroup,
		deleteDewormingGroup,
		deleteServiceGroup,

		getProductTypeList,
		setProductType,
		deleteProductType,
		getProductTypeDl
	} from '../../../api/productApi.js'
	export default {
		components: {
			page,
		},
		data() {
			return {
				activeName: '1',
				fixedHeight:'',
				goodsGroupData: [],
				yimiaoGroupData: [],
				quchongGroupData: [],
				serviceGroupData: [],
				goodsGroupParams: {
					"pageIndex": 0,
					"pageSize": 0,
					"keyword": "",
					"applytype": "",
					"categoryId": "",
					"shopId": ""
				},
				yimiaoGroupParams: {
					"pageIndex": 0,
					"pageSize": 0,
					"keyword": "",
					"applytype": "",
					"categoryId": "",
					"shopId": "",
					"buyway": ""
				},
				quchongGroupParams: {
					"pageIndex": 0,
					"pageSize": 0,
					"keyword": "",
					"applytype": "",
					"categoryId": "",
					"shopId": "",
					"weight": 0,
					"buyway": ""
				},
				serviceGroupParams: {
					"pageIndex": 0,
					"pageSize": 0,
					"keyword": "",
					"applytype": "",
					"categoryId": "",
					"shopId": ""
				},
				params:{
					pageIndex:1,
					pageSize:10,
					keyword:'',
					applytype:'',
					shopId:'',
				},

				isHighlight: true,

				total: 0,
				productTypeIds: [],
				categoryData: [],
				dialogProductType: false,
				editProductParams: {
					status: 1,
					category: '套餐',
					typeName: '',
					parentId: '',
				},

				storeIds: [],
			}
		},

		methods: {
			getGoodsGroupList() {
				getGoodsGroupList(this.params).then(res => {
					if (res.code == 0) {
						this.goodsGroupData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			getVaccineGroupList() {
				getVaccineGroupList(this.params).then(res => {
					if (res.code == 0) {
						this.yimiaoGroupData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			getDewormingGroupList() {
				getDewormingGroupList(this.params).then(res => {
					if (res.code == 0) {
						this.quchongGroupData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			getServiceGroupList() {
				getServiceGroupList(this.params).then(res => {
					if (res.code == 0) {
						this.serviceGroupData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			clickSearch() {
				this.params.pageIndex = 1;
				if(this.activeName=='1'){
					this.getGoodsGroupList();
				}else if(this.activeName=='2'){
					this.getVaccineGroupList();
				}
				else if(this.activeName=='3'){
					this.getDewormingGroupList();
				}
				else if(this.activeName=='4'){
					this.getServiceGroupList();
				}
			},
			changePage(val) {
				this.params.pageIndex = val;
				if(this.activeName=='1'){
					this.getGoodsGroupList();
				}else if(this.activeName=='2'){
					this.getVaccineGroupList();
				}
				else if(this.activeName=='3'){
					this.getDewormingGroupList();
				}
				else if(this.activeName=='4'){
					this.getServiceGroupList();
				}
			},
			addGoods() {
				if(this.activeName=='1'){
					this.$router.push({
						path: '/group/addgoodsgroup',
					})
				}else if(this.activeName=='2'){
					this.$router.push({
						path: '/group/addyimiaogroup',
					})
				}else if(this.activeName=='3'){
					this.$router.push({
						path: '/group/addquchonggroup',
					})
				}else if(this.activeName=='4'){
					this.$router.push({
						path: '/group/addservicegroup',
					})
				}
				
			},
			getStoreInfo(shopinfo) {
				this.editParams.shop_info = shopinfo;
			},

			edit(id,type) {
				if(type==1){
					this.$router.push({
						path: '/group/addgoodsgroup',
						query: {
							id,
						}
					})
				}else if(type==2){
					this.$router.push({
						path: '/group/addyimiaogroup',
						query: {
							id,
						}
					})
				}else if(type==3){
					this.$router.push({
						path: '/group/addquchonggroup',
						query: {
							id,
						}
					})
				}else{
					this.$router.push({
						path: '/group/addservicegroup',
						query: {
							id,
						}
					})
				}
				
			},
			
			deleted(id,type) {
				this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let http;
					if(type==1){
						http = deleteGoodsGroup({id})
					}else if(type==2){
						http = deleteVaccineGroup({id})
					}
					else if(type==3){
						http = deleteDewormingGroup({id})
					}
					else if(type==4){
						http = deleteServiceGroup({id})
					}
					http.then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							// this.params.pageIndex = 1;
							if(type==1){
								this.getGoodsGroupList();
							}else if(type==2){
								this.getVaccineGroupList();
							}
							else if(type==3){
								this.getDewormingGroupList();
							}
							else if(type==4){
								this.getServiceGroupList();
							}
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			lookdetail(id) {
				console.log(id);
			},

			addProductType(data) {
				if (data) {
					this.editProductParams.parentId = data.id;
					this.editProductParams.typeName = '';
					this.editProductParams.typeId = '';
				} else {
					this.editProductParams.parentId = this.categoryData[0].id;
					this.editProductParams.typeName = '';
				}

				this.dialogProductType = true;

			},

			onSubmitProductType() {
				if (!this.editProductParams.typeName) {
					this.$message({
						type: 'warning',
						message: '类型名称不能为空'
					});
				} else {
					setProductType(this.editProductParams).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '设置成功'
							});
							this.dialogProductType = false;
							this.getProductTypeList();
						}
					})
				}

			},
			remove(node, data) {
				this.$confirm('请谨慎操作！此操作将永久删除此类型，那么关联此类型的服务将被波及?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteProductType({
						id: data.id
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getProductTypeList();
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			getProductTypeList() {
				getProductTypeList({
					category: '套餐'
				}).then(res => {
					if (res.code == 0) {
						this.categoryData = res.data;

					}
				})
			},
			editProductType(data) {
				console.log(data)
				this.dialogProductType = true;
				this.editProductParams.typeId = data.id;
				this.editProductParams.typeName = data.label;
				this.editProductParams.parentId = '';

			},
			handleNodeClick(data) {
				
				
				this.params.categoryId = data.id;
				this.params.pageIndex =1;
				//疫苗
				if(data.code=="vaccine"){
					this.activeName =2;
					this.getVaccineGroupList();
					
				} else if(data.code=="deworming"){//驱虫
				this.activeName =3;
				this.getDewormingGroupList();
				}
				else if(data.code=="service"){//服务
				this.activeName =4;
				this.getServiceGroupList();
				}else{
					this.activeName =1;
					this.getGoodsGroupList();
				}
				this.getProductGoodsList();
			},
			changeCategory(val) {
				if (val.length > 0) {
					getProductTypeDl({
						id: val[val.length - 1]
					}).then(res => {
						if (res.code == 0) {
							this.editParams.basic_info.category_info['name'] = res.data.name;
							this.editParams.basic_info.category_info['_id'] = res.data._id;
							this.editParams.basic_info.category_list = res.data.parent_all;
						}
					})
				}
			},
			resetProductType() {
				this.isHighlight = false;
				this.params.categoryId = '';
				if(this.activeName=='1'){
					this.getGoodsGroupList();
				}else if(this.activeName=='2'){
					this.getVaccineGroupList();
				}
				else if(this.activeName=='3'){
					this.getDewormingGroupList();
				}
				else if(this.activeName=='4'){
					this.getServiceGroupList();
				}
				
			},
			relationconsum(row,type){
				
				this.$router.push({
					path:'/group/relationconsum',
					query:{
						product_name:row.title,
						product_id:row.groupId,
						relation_type:type,
					}
				})
			},
			renderContent(h, { node, data}) {
				return (
				<span  class="custom-tree-node" >
				<span>{node.label}</span>
				<span class='custom-tree-btn'  v-if="$buttonAuthority('chanpin-goods-sort')">
				<el-button size="mini" type="text" icon = 'el-icon-plus' on-click={ () => this.addProductType(data) }></el-button>
				<el-button size="mini" type="text" icon = 'el-icon-edit' on-click={ () => this.editProductType(data) }></el-button>
				<el-button size="mini" type="text" icon = 'el-icon-delete' on-click={ () => this.remove(node, data) }></el-button>
				</span>
				</span>
				)   
			},

			handleSelect(key) {
				this.activeName = key;
				this.params.pageIndex = 1;
				if(key == '1'){
					this.getGoodsGroupList();
				}else if(key == '2'){
					this.getVaccineGroupList();
				}
				else if(key == '3'){
					this.getDewormingGroupList();
				}
				else if(key == '4'){
					this.getServiceGroupList();
				}
				console.log(key)
			},
			
			
		},
		created() {
			this.fixedHeight = document.documentElement.clientHeight - 86;
			if(this.$route.query.type){
				if(this.$route.query.type==1){
					this.activeName = '1'
					this.getGoodsGroupList();
				}else if(this.$route.query.type==2){
					this.activeName = '2';
					this.getVaccineGroupList();
				}
				else if(this.$route.query.type==3){
					this.activeName = '3';
					this.getDewormingGroupList();
				}
				else if(this.$route.query.type==4){
					this.activeName = '4'
					this.getServiceGroupList();
				}
			}else{
				this.getGoodsGroupList();
			}
			
			
			this.getProductTypeList()
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		.searchbox {
			background-color: #fff;
			height: 72px;
			display: flex;
			align-items: center;
		}

		.con {
			display: flex;
			margin-top: 20px;

			.left {
				width: 180px;
				background-color: #fff;
				margin-right: 20px;
				padding: 10px;
				&::-webkit-scrollbar {
					width: 4px;
					// height: 4px;
				}
				.elTree{
					font-size: 12px;
					::v-deep .custom-tree-node{
						flex: 1;
						display: flex;
						align-items: center;
						justify-content: space-between;
						font-size: 12px;
						padding-right: 8px;
					}
					::v-deep .custom-tree-btn{
						display: none;
					}
					::v-deep .custom-tree-node:hover .custom-tree-btn{
						display: block;
					}
				}
			}

			.table {
				flex: 1;
				background-color: #fff;
				padding: 0 20px;
			}
		}
	}
	
	
	.tabLine{
		display: flex;
		.tabItem {
			margin-bottom: 10px;
			width:88px;
			box-sizing: border-box;
			line-height: 36px;
			text-align: center;
			border-right: 1px solid #F2F2F2;
			cursor: pointer;
			font-size: 14px;
			background-color: #fff;
			&.active {
				color: $mainColor;
			}
		}
	}
</style>
